import { type SyncApp } from '../../server/sync';
import { itemsPullOutput } from '../../shared/sync/items';
import { type Checkpoint, syncErrorSchema } from '../../shared/sync/schemas';
import { hc } from 'hono/client';

const client = hc<SyncApp>('/api/sync', {
  fetch: (input: RequestInfo | URL, init?: RequestInit) =>
    fetch(input, { ...init, credentials: 'include' }),
});

type FetchLike = { json: () => Promise<unknown>; ok: boolean; status: number };

const throwSyncError = async (res: FetchLike): Promise<never> => {
  let body: unknown;
  try {
    body = await res.json();
  } catch {
    throw new Error(`sync ${res.status}`);
  }

  const parsed = syncErrorSchema.safeParse(body);
  const code = parsed.success ? parsed.data.code : 'BAD_REQUEST';
  const message = parsed.success ? parsed.data.message : `sync ${res.status}`;
  throw new Error(`[${code}] ${message}`);
};

export const pullItems = async (input: {
  batchSize: number;
  checkpoint: Checkpoint | null;
  processId: string;
}) => {
  const res = await client.v1.items.pull.$post({
    json: {
      batchSize: input.batchSize,
      checkpoint: input.checkpoint,
      processId: input.processId,
    },
  });
  if (!res.ok) {
    await throwSyncError(res);
  }

  return itemsPullOutput.parse(await res.json());
};
